@if (typeReport()) {
  @if (info(); as info) {
    <div class="flex justify-between items-center w-full py-1 mb-3">
      <span class="text-[10px] font-bold uppercase max-w-fit w-full mr-1">Cluster</span>
      <span class="h-[1px] w-full bg-[#022D35]"></span>
      <app-info class="w-[14px] h-[14px] ml-1" [currentColor]="'text-[#9AABAE]'"
                [text]="'The analyzed address has been identified as belonging to the following entity.'"></app-info>
    </div>

    <div class="bg-[#F0F3F3] rounded-[6px] py-1 px-2">
      <p class="leading-[1.3] font-bold text-[#234542] pb-1 !mb-[6px]">{{ info.name }}</p>
      <p class="!mb-5">{{ info.category }}</p>
      @if (info.description) {
        <div class="relative">
          <span class="block leading-[1.3] overflow-hidden pr-6 text-[12px] text-[#45525B80]"
                [ngClass]="(stateClusterDetail()) ? 'max-h-none' : 'max-h-0'">{{ info.description }}</span>
          <button class="absolute bottom-0 right-0" (click)="toggleRentalDetail()">
            <mat-icon class="text-[#C92F29]" [class.rotate-180]="!stateClusterDetail()">keyboard_arrow_down</mat-icon>
          </button>
        </div>
      }
    </div>
  }
}
